function getTitle(tag) {
  if (tag.id !== "title") {
    return;
  }
  const value = tag.attributes.find((v) => v.key === "content");
  if (!value) {
    return;
  }
  return value.value;
}
function getTagObject(attributes) {
  return attributes.reduce((acc, v) => {
    acc[v.key] = v.value;
    return acc;
  }, {});
}
export function buildDrupalMetatags(data) {
  try {
    let schemaOrg = "";
    let tags = [];
    if (data && "route" in data && data.route && "metatags" in data.route) {
      const route = data.route;
      schemaOrg = route.schemaOrgMetatags?.json || "";
      tags = route.metatags;
    }
    if (data && "metatags" in data) {
      schemaOrg = data.schemaOrgMetatags?.json || "";
      tags = data.metatags || [];
    }
    const link = [];
    const meta = [];
    const script = [];
    if (schemaOrg) {
      script.push({
        type: "application/ld+json",
        innerHTML: schemaOrg
      });
    }
    let title = "";
    for (let i = 0; i < tags.length; i++) {
      const tag = tags[i];
      const tagTitle = getTitle(tag);
      if (tagTitle) {
        title = tagTitle;
      } else {
        const item = getTagObject(tag.attributes);
        // Add unique key for proper tag replacement in Nuxt's useHead
        item.key = tag.id;
        if (tag.tag === "link") {
          link.push(item);
        } else if (tag.tag === "meta") {
          meta.push(item);
        }
      }
    }
    return { link, meta, title, script, schemaOrg };
  } catch (e) {
    console.log("Error in Vuepal:");
    console.log(e);
  }
  return { link: [], meta: [], script: [], title: "", schemaOrg: "" };
}
